import React from 'react';

const AluminiSettings = () => {
  return (
    <div className="min-h-screen bg-slate-50 p-3 md:p-6">
      <div className="mx-auto max-w-7xl">
        <div className="mb-6 md:mb-8">
          <h1 className="text-2xl font-bold text-slate-900 md:text-3xl">Settings</h1>
          <p className="mt-2 text-sm text-slate-600 md:text-base">
            Manage your account settings and preferences
          </p>
        </div>

        <div className="rounded-xl border border-slate-100 bg-white p-4 shadow-sm md:p-6">
          <h2 className="mb-4 text-lg font-semibold text-slate-900 md:text-xl">Account Settings</h2>
          <p className="text-slate-600">Settings management features will be available here.</p>
        </div>
      </div>
    </div>
  );
};

export default AluminiSettings;
